import React, { useEffect, useState } from 'react'
import { Box, Button, Loader, Modal, Table, Text, TextField } from '../../components';
import { Col, DatePicker, Input, Pagination, Row, TimePicker, pagination } from 'antd';
import { ApiCaller, Colors, Fonts, Utils } from '../../config';
import useMedia from 'use-media';
import { useDispatch, useSelector } from 'react-redux';
import { useNavigate } from 'react-router';
import { HiOutlineSearch } from 'react-icons/hi';
import './style.css'
import { DisputeActions, JobActions } from '../../store/actions';
import { JobsManagementReducer } from '../../store/reducers';
import { Images, Constants } from "../../config";

const deleteJob = async (id) => (await ApiCaller.Delete(`/admin/job/${id}`));

const statusOptions = [
    { label: "All", value: "" },
    { label: "Pending", value: "PENDING" },
    { label: "Admin Assigned", value: "ADMIN_ASSIGNED" }
];

const bookingTypeOptions = [
    { label: "All", value: "" },
    { label: "Quote", value: "quoted" },
    { label: "Direct", value: "direct" }
];

const JobManagement = () => {


    const dispatch = useDispatch();
    const navigate = useNavigate();

    const serviceUsers = useSelector((state) => state.serviceUsers);

    const [exportModal, setExportModal] = useState(false);
    const [deleteModal, setDeleteModal] = useState(false);
    const [deleteId, setDeleteId] = useState(null);
    const { isLoading, allJobs } = useSelector(state => state?.JobsManagementReducer);
    // console.log("isloading", isLoading);
    // console.log("allJobs", allJobs);


    const [state, setState] = useState({
        limit: 10,
        offset: 0,
        page: 1,
        search: "",
        status: "",
        startDate: "",
        endDate: "",
        jobType: ""
    });

    useEffect(() => {
        if (state) {
            // console.log('state in jobmanagement component', state);
            dispatch(JobActions.getAllJobs(state))
        }
    }, [state])


    // status handler
    const handleStatusFilter = (checked, id) => {
        console.log('handleStatusFilter', checked);

        setState({
            ...state,
            offset: 0,
            status: checked,
        });
    };

    // booking type handler
    const handleBookingTypeFilter = (checked, id) => {
        setState({
            ...state,
            offset: 0,
            jobType: checked,
        });
    };

    // search handler
    const handleSearchUsers = (e) => {
        // console.log('handleSearchUsers ', e);

        setState({
            ...state,
            offset: 0,
            search: e.target.value.trimStart(),
        });
    };

    // pagination handler
    const handlePaginationChange = (pageNumber) => {
        // console.log('pageNumber ',pageNumber);
        let offset = (pageNumber - 1) * state.limit;
        setState({ ...state, offset: offset, page: pageNumber });
    };

    // date handler
    const dateHandler = (date, dateStrings) => {
        // console.log("start and end date ",dateStrings[0], dateStrings[1]);
        setState({ ...state, offset: 0, startDate: dateStrings[0], endDate: dateStrings[1] })
    }

    // export date handler
    const exportDataHandler = () => {
        dispatch(JobActions.exportJobs(state, (res) => {
            // console.log("res", res);
            window.open(res, "_blank");
            setExportModal(false)
        }))
    }

    // dispute detail page navigator
    const disputeDetail = (id) => {
        // console.log('id', id);
        navigate(`/job-management-detail/${id}`)
    }

    const deleteModalHandler = () => {
        setDeleteModal(true)
    }


    const deleteJobHandler = async () => {
        try {
            const id = deleteId;
            let res = await deleteJob(id);
            if (res?.data?.status == 200 || res?.status == 200) {
                Utils.showSnackBar({
                    message: res?.data?.data?.message,
                    severity: "error"
                });
                setDeleteModal(false);
                dispatch(JobActions.getAllJobs(state));
            }
        } catch (error) {
            console.log(error)
        }
    }

    // console.log("constants", Constants?.jobStatusList);


    return (
        <Box>
            <Row justify="space-between" align='middle'>
                <Col className="flex-start" lg={7} md={24}>
                    <Text.Heading
                        fontSize={24}
                        fontFamily={Fonts["Poppins-SemiBold"]}
                        color={Colors.Black}
                        fontWeight={600}
                        text={"Job Management"}
                    />
                </Col>
                <Col lg={17} md={24} sm={24} xs={24} className='filters'>
                    <Row className='filters-container' style={{ width: "100%" }}>
                        <Col lg={8} md={24} sm={24} xs={24} className='filters-item'>
                            <Button.Basic className={'export-btn'} text={'Export Data'} onClick={() => setExportModal(true)} />
                        </Col>

                        <Col lg={8} md={24} sm={24} xs={24} className='filters-item'>
                            <TextField.SelectField
                                placeholder="Select"
                                size="large"
                                id="provider-management-select"
                                type="text"
                                disabled={false}
                                required={false}
                                value={state?.status ? state?.status : "All Status"}
                                label=""
                                defaultValue="All Status"
                                error={false}
                                helperText=""
                                onChange={handleStatusFilter}
                                className='status-selector'
                                data={statusOptions}
                            />
                        </Col>
                        <Col lg={7} md={24} sm={24} xs={24} className='filters-item'>
                            <TextField.SelectField
                                placeholder="Select"
                                size="large"
                                id="booking-type-select"
                                type="text"
                                disabled={false}
                                required={false}
                                value={state?.jobType ? state?.jobType : "All Types"}
                                label=""
                                defaultValue="All Types"
                                error={false}
                                helperText=""
                                onChange={handleBookingTypeFilter}
                                className='status-selector'
                                data={bookingTypeOptions}
                            />
                        </Col>
                    </Row>
                    <Row className='filters-container' style={{ width: "100%" }}>
                        <Col lg={12} md={24} sm={24} xs={24} className='filters-item' >
                            <DatePicker.RangePicker className='range-picker-status' onChange={dateHandler} />
                        </Col>
                        <Col lg={11} md={24} sm={24} xs={24} className='filters-item'>
                            <TextField.CustomInput
                                placeholder="Search"
                                size="large"
                                // id="provider-management-search"
                                type="text"
                                disabled={false}
                                required={false}
                                value={state?.search}
                                label=""
                                defaultValue=""
                                error={false}
                                helperText=""
                                onChange={handleSearchUsers}
                                prefix={<HiOutlineSearch color={Colors.dropdownTextColor} />}
                                bgColor={Colors.dropdownBgColor}
                                color={Colors.dropdownTextColor}
                                className="user-search-field"
                            />
                        </Col>



                    </Row>
                </Col>
            </Row>
            <Row justify="space-between" className="mt-20">
                <Col span={24}>
                    {isLoading ? (
                        <Col className='loader table-loader-container'>
                            <Loader.Circular />
                        </Col>
                    ) : (
                        <>
                            <Table.AntDesignTable
                                className="user-table"
                                columns={[
                                    {
                                        title: "Job Details",
                                        dataIndex: "jobDetails",
                                        key: "name",
                                        render: (text, record) => (
                                            <div className='profile-container'>
                                                <img
                                                    src={
                                                        record?.services[0]?.imageUrl &&
                                                            /\.(jpg|jpeg|png|gif|webp|svg)$/i.test(record.services[0].imageUrl)
                                                            ? record.services[0].imageUrl
                                                            : Images.MobrageIcon
                                                    }
                                                    alt="user"
                                                    className="service-user-img"
                                                />
                                                <span>{record?.services[0]?.name?.length > 15 ? record?.services[0]?.name?.slice(0, 16) + '...' : record?.services[0]?.name}</span>
                                            </div>
                                        ),
                                    },
                                    // {
                                    //     title: "User",
                                    //     dataIndex: "disputeBy",
                                    //     key: "type",
                                    //     render: (text, record) => (
                                    //         <span>
                                    //             {record?.disputeBy?.type ? record?.disputeBy?.type : '-'}
                                    //         </span>
                                    //     ),
                                    // },
                                    {
                                        title: "Creation Date",
                                        dataIndex: "creationDate",
                                        key: "createdAt",
                                        render: (text, record) => (
                                            <span>
                                                {
                                                    Utils.formatTimestamp(record?.createdAt)
                                                }
                                            </span>
                                        ),
                                    },

                                    // {
                                    //     title: "Price",
                                    //     dataIndex: "booking",
                                    //     key: "quotes",
                                    //     render: (text, record) => (
                                    //         <span>
                                    //             {record?.booking?.quotes?.length > 0 ? '£ ' + record?.booking?.quotes[0]?.price : 0}
                                    //         </span>
                                    //     ),
                                    // },
                                    {
                                        title: "Status",
                                        dataIndex: "status",
                                        key: "status",
                                        render: (text, record) => (
                                            // <span>
                                            //     {
                                            //         // record?.status == 'PENDING' ?
                                            //         //     <div className='pending-status'>{record?.status}</div>
                                            //         //     :
                                            //         <div style={{ padding: '10px', width: '100px', color: '#fff', textAlign: 'center', borderRadius: '10px', }} className={` ${record?.status == 0 ? 'job-status job-status-pending' : 'job-status job-status-resolved'}`}>{record?.status == 0 ? 'PENDING' : 'ADMIN ASSIGNED'}</div>}
                                            // </span>
                                            <span style={{ padding: '10px', width: '100px', color: '#fff', textAlign: 'center', borderRadius: '10px', background: `${record?.status == 0 ? '#FAB700' : '#00B517'}` }}>{record?.status == 0 ? 'PENDING' : 'ADMIN ASSIGNED'}</span>
                                        ),
                                    },
                                    {
                                        title: "Type",
                                        dataIndex: "bookingType",
                                        key: "type",
                                        render: (text, record) => (
                                            <span>
                                                {record?.bookingType ? record?.bookingType : '-'}
                                            </span>
                                        ),
                                    },
                                    {
                                        title: "Action",
                                        dataIndex: "adminAction",
                                        key: "adminAction",
                                        render: (text, record) => (
                                            <>
                                                {
                                                    <>
                                                        {/* <img
                                                            onClick={() => {
                                                                // setSelectedUser(record);
                                                                // setShowModal(true);
                                                            }}
                                                            src={Images.AssignIcon}
                                                            alt=""
                                                            className='jobList-action-1'
                                                        /> */}
                                                        <img
                                                            onClick={() => {
                                                                disputeDetail(record?.id)
                                                            }}
                                                            src={Images.ViewIcon}
                                                            alt=""
                                                            className='jobList-action-1'
                                                        />
                                                        <img
                                                            onClick={() => {
                                                                setDeleteModal(true);
                                                                setDeleteId(record?.id)
                                                            }
                                                            }
                                                            src={Images.DeleteIcon}
                                                            alt=""
                                                        />
                                                    </>

                                                }
                                            </>
                                        ),
                                    },
                                ]}
                                data={allJobs?.jobs}
                                pagination={true}
                                rowKey="key"
                            // loading={false}

                            />
                            <Row justify="center" className="mt-20">
                                <Col>
                                    <Pagination
                                        responsive="true"
                                        showLessItems="true"
                                        pageSize={state?.limit}
                                        current={state?.page}
                                        total={allJobs?.count}
                                        onChange={handlePaginationChange}
                                    />
                                </Col>
                            </Row>
                        </>
                    )}
                </Col>
            </Row>
            {
                exportModal &&
                <Modal.ConfirmationModal
                    title={""}
                    isModalVisible={exportModal}
                    heading={"Are you sure you want to export?"}
                    handleCancel={() => setExportModal(false)}
                    handleDelete={() => exportDataHandler()}
                >
                </Modal.ConfirmationModal>
            }
            {
                deleteModal &&
                <Modal.ConfirmationModal
                    title={""}
                    isModalVisible={deleteModal}
                    heading={"Are you sure you want to delete?"}
                    handleCancel={() => setDeleteModal(false)}
                    handleDelete={() => deleteJobHandler()}
                >
                </Modal.ConfirmationModal>
            }
        </Box>
    )
}

export default JobManagement